import { StoreContext } from "@roc/feature-app-core";
import { useContext } from "react";
import { CreateListStore } from "../stores/createListStore";

export const useCreateListStore = () => useContext<{
  createListStore: CreateListStore
}>(StoreContext);